import { Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { CardViewModel } from '../cards/card-view-model';
import { Blackjack } from 'game-logic';

export class CardDeckViewModel {
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get interfaceEventQueue() {
    return this.gameServices.interfaceEventQueue;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get cardViewModelChanges$() {
    return this.cardViewModelChanges.asObservable();
  }

  private cardViewModels: CardViewModel[] = [];
  private readonly onResetGameScene = new Subject<void>();
  private readonly cardViewModelChanges = new Subject<{ viewModel: CardViewModel }>();

  constructor(private gameServices: GameServices) {}

  public addDeckCard(card: Blackjack.Card, index: number) {
    const cardViewModel = new CardViewModel(this.gameServices, card, index, Blackjack.PileId.Deck);
    this.cardViewModels.push(cardViewModel);
    this.cardViewModelChanges.next({ viewModel: cardViewModel });
  }

  public resetGameScene() {
    this.onResetGameScene.next();
    this.cardViewModels = [];
  }
}
